import "../styles/cards.scss";

export function AboutCard1(props) {
    return (
        <div className="aboutCard1">
            <div className="texts">
                <div className="title">{props.title}</div>
                <div className="inner">{props.text}</div>
                {/* <div className="btn">View More</div> */}
            </div>
            <div className="space"></div>
            <div className="img">
                <img src={props.img}></img>
            </div>
        </div>
    );
}
export function AboutCard1_1(props) {
    return (
        <div className="aboutCard1 rev">
            <div className="img">
                <img src={props.img}></img>
            </div>
            <div className="space"></div>
            <div className="texts">
                <div className="title">{props.title}</div>
                <div className="inner">{props.text}</div>
                {/* <div className="btn">View More</div> */}
            </div>
        </div>
    );
}
